module.exports = __webpack_public_path__ + "static/media/silkscreen.e64d5402.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SilkScreen/silkscreen.ttf
// module id = 23
// module chunks = 0